export type Fragments = {
  text?: TextFragment[];
};

export type TextFragment = {
  range: [number, number];
  element: string;
  // TODO remove
  attributes?: {
    'data-json': string;
  };
  value?: string;
};

const parseInline = (text: string, fragments: Fragments) => {
  if (!fragments) {
    return text;
  }

  const result = (fragments?.text || []).map((fragment) => {
    switch (fragment.element) {
      case 'B':
        return `<b>${fragment.value}</b>`;
      case '#text':
      case 'SUP':
      case 'CODE': {
        return fragment.value;
      }
      case 'A': {
        if (!fragment.attributes['data-json']) {
          return fragment.value;
        }
        try {
          const parsed = JSON.parse(fragment.attributes['data-json']);
          const href = parsed.url ? parsed.url : process.env.NEXT_PUBLIC_HOST + parsed.reference.slugPath;

          return `<a href="${href}">` + `${fragment.value}` + `</a>`;
        } catch {
          return fragment.value;
        }
      }
      case 'BR': {
        return '<br/>';
      }
      default: {
        // eslint-disable-next-line no-console
        console.log('editorJsToSimpleHtml: trying to parse unedfined element type', fragment.element);
        return '';
      }
    }
  });
  return result.join('');
};

export const editorJsToSimpleHtml = (text: string) => {
  if (text.includes('"blocks":')) {
    const result = JSON.parse(text).blocks.map((block) => {
      switch (block.type) {
        case 'paragraph': {
          return parseInline(block.data.text, block.fragments);
        }
        case 'list': {
          if (!Array.isArray(block.data.items)) {
            return '';
          }

          const listType = block.data.style === 'ordered' ? 'ol' : 'ul';

          return `<${listType}>${block.data.items
            .map((li: string, listIndex: number) => `<li>${parseInline(li, block.fragments[listIndex])}</li>`)
            .join('')}</${listType}>`;
        }
        case 'image': {
          if (!block.data?.file?.url) {
            return '';
          }

          return `<img src=${process.env.NEXT_PUBLIC_HOST}${block.data.file.url} alt=(${block.data.file.alt}) />`;
        }
        case 'delimiter':
          return '<hr/>';
        default: {
          // eslint-disable-next-line no-console
          console.error(`editorJsToSimpleHtml: trying to parse undefined block type ${block.type}`);
          return '';
        }
      }
    });

    return result.join('<br/>');
  }

  return text;
};
